// @flow
import FingerprintJs from "fingerprintjs2";
import user from "app/redux/actions/user";
import store from "app/redux/store";

function getFingerprintHash() {
  return FingerprintJs.getPromise().then(function(result) {
    const values = result.map(component => component.value);
    const hash = FingerprintJs.x64hash128(values.join(""), 31);
    store.dispatch(user.deviceFingerprint(hash));
  });
}

const deviceFingerprintHash = new Promise(function(resolve) {
  if (window.requestIdleCallback) {
    requestIdleCallback(function() {
      resolve(getFingerprintHash());
    });
  } else {
    setTimeout(function() {
      resolve(getFingerprintHash());
    }, 500);
  }
});

export default deviceFingerprintHash;
export { deviceFingerprintHash };
